export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_VERSAPAY_LINK = 'GET_VERSAPAY_LINK'
export const GET_NORTHCAPITAL_CONFIRMATION = 'GET_NORTHCAPITAL_CONFIRMATION'
